import React, { useEffect, useState } from 'react';
import styles from './paulosnesi_2.module.scss';
import BackgroundLinks from '../paulosnesi_/src/background-links.png';
import BannerGrupoVip from '../paulosnesi_/src/1.png';
import BannerShopee from '../paulosnesi_/src/2.png';
import BannerTiktokShop from '../paulosnesi_/src/3.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5547988046604';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const INSTAGRAM_URL = 'https://www.instagram.com/paulosnesi_';
const TIKTOK_URL = 'https://www.tiktok.com/@paulorecomendaoficial?_r=1&_t=ZS-99x0JqbkZIA';
const GRUPO_VIP_URL = 'https://chat.whatsapp.com/CinjPktkaftFH9fzPWWrGj?mode=gi_t';
const VITRINE_SHOPEE_URL = 'https://collshp.com/paulonesi604?view=storefront';
const VITRINE_TIKTOK_URL = 'https://vt.tiktok.com/ZSbLT59Tx/?page=TikTokShop';
const VITRINE_TIKTOK_WEB_URL = 'https://www.tiktok.com/@paulorecomendaoficial?tab=shop';
const VITRINE_TIKTOK_APP_URL =
    'snssdk1180://ec/showcase?author_id=7410165098771661830&filter_tab=2';
const VITRINE_TIKTOK_SAFARI_URL = `x-safari-https://${VITRINE_TIKTOK_WEB_URL.replace(/^https:\/\//i, '')}`;
const ICON_COLOR = '#ffffff';

const isInAppBrowser = () =>
    /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FBSS|Line\//i.test(navigator.userAgent);

const isAndroid = () => /Android/i.test(navigator.userAgent);

const tiktokAppHref = () => {
    if (!isAndroid()) return VITRINE_TIKTOK_APP_URL;
    return `intent://ec/showcase?author_id=7410165098771661830&filter_tab=2#Intent;scheme=snssdk1233;package=com.zhiliaoapp.musically;end`;
};

const copyText = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        const input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        const ok = document.execCommand('copy');
        input.remove();
        return ok;
    }
};

type BannerItem = {
    image: string;
    link: string;
    alt: string;
    needsExternalBrowser?: boolean;
};

const banners: BannerItem[] = [
    { image: BannerGrupoVip, link: GRUPO_VIP_URL, alt: 'Grupo VIP — Caçador de Ofertas' },
    {
        image: BannerTiktokShop,
        link: VITRINE_TIKTOK_URL,
        alt: 'Vitrine TikTok Shop',
        needsExternalBrowser: true,
    },
    { image: BannerShopee, link: VITRINE_SHOPEE_URL, alt: 'Vitrine Shopee' },
];

const Paulosnesi_2: React.FC = () => {
    const [browserHelpOpen, setBrowserHelpOpen] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);

    useEffect(() => {
        if (!browserHelpOpen) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setBrowserHelpOpen(false);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [browserHelpOpen]);

    return (
        <div className={styles.paulosnesi_2}>
            <div className={styles.main}>
                <img
                    className={styles.cardImage}
                    src={BackgroundLinks}
                    alt="Paulo Nesi — estratégias digitais que vendem"
                    decoding="async"
                />
                <div className={styles.content}>
                    <div className={styles.socialRow}>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="WhatsApp"
                        >
                            <WhatsappIcon height="26" color={ICON_COLOR} />
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <InstagramIcon height="22" color={ICON_COLOR} />
                        </a>
                        <a
                            href={TIKTOK_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="TikTok"
                        >
                            <TiktokIcon height="22" color={ICON_COLOR} />
                        </a>
                    </div>
                    <section className={styles.bio} aria-label="Sobre Paulo Nesi">
                        <p className={styles.bioEyebrow}>Sobre</p>
                        <p className={styles.bioLead}>
                            Sou Paulo Sérgio Nesi, pai, empreendedor e creator, movido por negócios,
                            vendas e oportunidades.
                        </p>
                        <div className={styles.bioStat}>
                            <strong>+ R$ 9 milhões</strong>
                            <span>em vendas para marcas parceiras no TikTok Shop</span>
                        </div>
                        <p className={styles.bioText}>
                            Transformei conteúdo em um negócio. Hoje uno estratégia, influência e
                            performance para conectar produtos às pessoas e transformar atenção em
                            resultado.
                        </p>
                    </section>
                    {banners.map((banner) => (
                        <a
                            key={banner.alt}
                            href={banner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.contentLink}
                            onClick={(e) => {
                                if (!banner.needsExternalBrowser || !isInAppBrowser()) return;
                                e.preventDefault();
                                setLinkCopied(false);
                                setBrowserHelpOpen(true);
                            }}
                        >
                            <img
                                className={styles.contentImage}
                                src={banner.image}
                                alt={banner.alt}
                                decoding="async"
                            />
                        </a>
                    ))}
                </div>
            </div>

            {browserHelpOpen && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setBrowserHelpOpen(false)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="paulosnesi-2-tiktok-help-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setBrowserHelpOpen(false)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        <p className={styles.modalEyebrow}>TikTok Shop</p>
                        <h2 id="paulosnesi-2-tiktok-help-title" className={styles.modalBrand}>
                            Abra no navegador
                        </h2>
                        <p className={styles.modalText}>
                            O link curto do TikTok Shop abre o aplicativo, e o Instagram bloqueia
                            isso. Escolha uma das opções:
                        </p>
                        <div className={styles.modalActions}>
                            <a
                                className={styles.modalAction}
                                href={VITRINE_TIKTOK_WEB_URL}
                                rel="noopener noreferrer"
                            >
                                Abrir vitrine neste navegador
                            </a>
                            <a className={styles.modalAction} href={tiktokAppHref()}>
                                Abrir no app TikTok
                            </a>
                            {!isAndroid() && (
                                <a className={styles.modalAction} href={VITRINE_TIKTOK_SAFARI_URL}>
                                    Abrir no Safari
                                </a>
                            )}
                            <button
                                type="button"
                                className={`${styles.modalAction} ${styles.modalActionSecondary}`}
                                onClick={async () => {
                                    const ok = await copyText(VITRINE_TIKTOK_WEB_URL);
                                    setLinkCopied(ok);
                                }}
                            >
                                {linkCopied ? 'Link copiado' : 'Copiar link da vitrine'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Paulosnesi_2;
